<template>
  <transition @enter="afterEnter" @before-enter="beforeEnter">
    <div class="move_dot" ref="ball" v-show="show">
      <!-- 小球图片 -->
      <img width="36" height="36" :src="dropImage" alt="" />
    </div>
  </transition>
</template>

<script>
export default {
  props: ['dropImage', 'targetId'],
  data() {
    return {
      elLeft: 0,
      elTop: 0,
      show: false // 是否开始起飞
    };
  },
  mounted() {
    this.init();
    // this.elLeft = event.target.getBoundingClientRect().left;
    //     this.elTop = event.target.getBoundingClientRect().top;
    // console.log();
  },
  methods: {
    addToCart(target) {
      const _target = target.$el.getBoundingClientRect();
      this.elLeft = _target.left;
      this.elTop = _target.top;
      this.show = true;
    },
    init() {
      // const target = document.getElementById('buycar');
      // this.elLeft = target.getBoundingClientRect().left;
      // this.elTop = target.getBoundingClientRect().top;
    },
    beforeEnter(el) {
      // 设置transform值
      el.style.transform = `translate3d(0px,0px , 10px)`;
      // 设置透明度
      el.style.opacity = 0;
    },
    afterEnter(el) {
      // 获取底部购物车徽标的位置
      const badgePosition = document.getElementById(this.targetId || 'buyCar').getBoundingClientRect();
      const _target = el.getBoundingClientRect();

      el.style.position = 'fixed';
      // 设置成 fixed 不然会被过滤框遮挡
      el.style.top = `${_target.top}px`;
      el.style.left = `${_target.left}px`;

      el.style.zIndex = 10;

      // 设置位移
      el.style.transform = `translate3d(${badgePosition.left - _target.left - 14}px,${
        badgePosition.top - _target.top + badgePosition.height / 2
      }px,0) scale(0.2, 0.2)`;

      // 增加贝塞尔曲线
      el.style.webkitTransform = el.style.transform = `translate3d(${badgePosition.left - _target.left - 14}px,${
        badgePosition.top - _target.top + badgePosition.height / 2
      }px,0) scale(0.2, 0.2)`;

      el.style.transition = 'transform .6s cubic-bezier(0.3, -0.25, 0.7, -0.15)';
      el.style.transition = 'transform .6s linear';

      el.style.transition = '-webkit-transform .6s cubic-bezier(0.3, -0.25, 0.7, -0.15)';
      el.style.transition = '-webkit-transform .6s linear';

      this.show = false;
      // 设置透明度
      el.style.opacity = 1;

      el.addEventListener('transitionend', () => {
        el.style.display = 'none';

        el.style.position = 'absolute';
        el.style.top = 0;
        el.style.left = 0;
        this.listenInCart();
      });
      el.addEventListener('webkitAnimationEnd', () => {
        el.style.display = 'none';

        el.style.position = 'absolute';
        el.style.top = 0;
        el.style.left = 0;
        this.listenInCart();
      });
    },
    listenInCart() {
      const { classList } = document.getElementById(this.targetId || 'buyCar');
      // 拿到购物车的DOM添加class
      if (classList) classList.add('moveToCart');
      setTimeout(() => {
        // 500毫秒后移除class
        if (classList) classList.remove('moveToCart');
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped>
.move_dot {
  width: 36px;
  height: 36px;
  transform: translate3d(0px, 0px, 10px);
  .img {
    width: 36px;
    height: 36px;
  }
}
</style>
